import Vue from 'vue';
import Router from 'vue-router';
import { routes } from '@/Routes';

import store from '@/store';
import { SecurityStoreMethods } from '@/store/security/SecurityStore';
import { SecurityService } from '@/security/SecurityService';

import { UserInfo } from '@/shared/models/UserInfo.model';
import { InvoicingService } from '@/services/invoicing/InvoicingService';

// Configuration du routeur
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    // Route non protégée, la navigation se poursuit.
    if (isAnonymousAllowed(to)) {
        next();
    } else if (!(await SecurityService.isAuthenticated())) {
        await SecurityService.login(to.path);

        // L'utilisateur doit être authentifié.
    } else {
        // Si on est authentifié mais que l'utilisateur dans le store n'est pas défini, il faut le charger depuis l'api.
        // Cas qui peut se présenter si on fait un refresh de la page par exemple.
        if (!store.getters[SecurityStoreMethods.GET_USERINFO]) {
            await SecurityService.init();
            await InvoicingService.init();
        }

        // L'utilisateur est déjà connecté, on vérifie qu'il n'y a pas une restriction de role.
        if (to.matched.some((record) => record.meta.policy)) {
            const currentUser: UserInfo = store.getters[SecurityStoreMethods.GET_USERINFO];

            // S'il n'a pas les privilèges suffisants, on le redirige vers l'accueil.
            if (currentUser !== undefined && to.meta !== undefined && to.meta.policy > currentUser.roleId) {
                return next({ path: "/" });
            }
        }
    
    
        next();
    }
});


function isAnonymousAllowed(route) {
    return route.matched.some(record => record.meta?.allowAnonymous);
}

export { router };
